import { Injectable } from '@angular/core';
import { getUrl, ResourceFactory } from '@ngxp/rest';
import { BinaryFileResource } from '@schir-int-client/binary-shared';
import { AufgabeLinkRel, AufgabeResource } from '@schir-int-client/aufgabe-shared';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { KorrespondenzVorlageLinkRel } from './korrespondenz-vorlage.linkrel';
import { KorrespondenzVorlage, KorrespondenzVorlageResource } from './korrespondenz-vorlage.model';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class KorrespondenzVorlageService {
	constructor(
		private resourceFactory: ResourceFactory,
		private httpClient: HttpClient
	) {}

	loadKorrespondenzVorlage(aufgabe: AufgabeResource): Observable<KorrespondenzVorlageResource> {
		return this.resourceFactory.from(aufgabe).get(AufgabeLinkRel.KORRESPONDENZ_VORLAGE);
	}

	createKorrespondenzVorlage(
		aufgabe: AufgabeResource,
		vorlage: KorrespondenzVorlage,
		vorlageId: number,
		verfahrenId: number
	): Observable<BinaryFileResource> {
		return this.httpClient.post<BinaryFileResource>(
			getUrl(aufgabe, AufgabeLinkRel.CREATE_KORRESPONDENZ_VORLAGE)
				.replace('{vorlageId}', String(vorlageId))
				.replace('{verfahrenId}', String(verfahrenId)),
			vorlage
		);
	}

	downloadKorrespondenzVorlage(aufgabe: AufgabeResource): Observable<BinaryFileResource> {
		return this.loadKorrespondenzVorlage(aufgabe).pipe(
			mergeMap(vorlage =>
				this.resourceFactory
					.from(vorlage)
					.get<BinaryFileResource>(KorrespondenzVorlageLinkRel.KORRESPONDENZ_VORLAGE_FILE)
			)
		);
	}

	deleteKorrespondenzVorlage(KorrespondenzVorlage: KorrespondenzVorlageResource): Observable<void> {
		return this.resourceFactory.from(KorrespondenzVorlage).delete(KorrespondenzVorlageLinkRel.DELETE);
	}
}
